import React, { useEffect } from 'react';
import { useContext } from 'react';
import AuthContext from '../store/auth-context';

const Introduction = () => {
  const context = useContext(AuthContext);

  useEffect(() => {
    context.pathnameHandler(window.location.pathname);
  });
  return (
    <div
      className={`main-screen__content  ${
        context.pathname === '/' ? 'show-section' : ''
      }`}
    >
      <div className='main-screen__content-header'>
        <h4>Hi, My name is</h4>
        <h1>Aisha Amate</h1>
        <h2>I build things on the web</h2>
      </div>
      <p className='main-screen__content-main'>
        I'm a fullstack developer based in Morden, UK. I have developed various
        projects utilising multiple technology stacks such as
        <span className='highlight'> React</span>, templating language such as
        <span className='highlight'> EJS</span>,
        <span className='highlight'> Node</span> and
        <span className='highlight'> Express</span> amongst few.
      </p>
      <p className='main-screen__content-main'>
        I specialise in developing but I occasionally create designs for clients
        with varying needs.
      </p>
    </div>
  );
};

export default Introduction;
